require("./bootstrap-vue.js");
require("./axios.js");
require("./aos.js");
require("./vee-validate.js");
require("./reCaptcha.js");
